import React from 'react'

function TenderOpticlean() {
  return (
    <embed src="\pdfs\EAT1.1.10.1_OC-Q_Opticlean_kr (1).pdf" width="100%" height="2100px" />
  )
}

export default TenderOpticlean